// ProductManagePage 常量配置
import type { ProductCategory, SortField } from './types';

// 分类选项
export const categoryOptions: { value: ProductCategory | 'all'; label: string }[] = [
  { value: 'all', label: '全部' },
  { value: 'all_in_one', label: '一体机' },
  { value: 'product', label: '产品' },
  { value: 'module', label: '模组' },
];

// 排序选项
export const sortOptions: { value: SortField; label: string }[] = [
  { value: 'name', label: '名称' },
  { value: 'created_at', label: '创建时间' },
  { value: 'models_count', label: '型号数量' },
  { value: 'category', label: '分类' },
];

// 分类标签映射
export const CategoryLabels: Record<ProductCategory, string> = {
  all_in_one: '一体机',
  product: '产品',
  module: '模组',
};

// 默认列宽
export const DEFAULT_COLUMN_WIDTHS = {
  category: 192, // 48 * 4 = 192px
  series: 224,   // 56 * 4 = 224px
  product: 256,  // 64 * 4 = 256px
};

// 列宽限制
export const COLUMN_WIDTH_MIN = 150;
export const COLUMN_WIDTH_MAX = 400;

// 默认型号表单数据
export const DEFAULT_MODEL_FORM = {
  model_name: '',
  pitch: '',
  brightness: '',
  cabinet_size: '',
  is_default: false,
};

// 默认产品表单数据
export const DEFAULT_PRODUCT_FORM = {
  name: '',
  name_en: '',
  category: 'product' as ProductCategory,
  series_name: '',
  image_url: '',
  pitch_range: '',
  size_specs: '',
  process_type: '',
  features: [] as string[],
  slogan: '',
  is_featured: false,
};
